module.exports = "<div *ngIf=\"source\" class=\"input-wrapper\">\n  <i class=\"fas fa-search\"></i>\n  <input #search class=\"search\" type=\"text\" [placeholder]=\"placeholder\" (keyup)=\"onSearch(search.value)\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/search-input/search-input.component.html
// module id = ./src/app/shared/search-input/search-input.component.html
// module chunks = main